import { render, staticRenderFns } from "./sba-status.vue?vue&type=template&id=1a50bd2d&"
import script from "./sba-status.vue?vue&type=script&lang=js&"
export * from "./sba-status.vue?vue&type=script&lang=js&"
import style0 from "./sba-status.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports